import React from "react";

import {
  Grid,
  Typography
} from "@mui/material";

import Button from "@mui/material/Button";
import "./index.css";

import { useNavigate } from "react-router";
import ListSocio from "./ListSocio";
import { usePersona } from "../../context/persona";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

export default function SocioPerson() {
  const { setInfoPersona } = usePersona();
  const navigate = useNavigate();

  const setObjSocio = (obj) => {
    setInfoPersona(obj.personaMs);
    navigate("new");
  }

  const openNew = () => {
    setInfoPersona({});
    navigate("new");
  }

  return (
    <Grid container>
      <Grid item xs={8} md={6}>
        <Typography variant="h2">
          Listado de Socios
        </Typography>
      </Grid>
      <Grid item xs={4} md={6} textAlign="right">
        <Button
          size="large"
          variant="contained"
          onClick={openNew}
          startIcon={<PersonAddAltIcon />}
        >
          Nuevo
        </Button>
      </Grid>
      <Grid item xs={12}>
        <ListSocio
          onSocioClick={setObjSocio}
        />
      </Grid >
    </Grid>
  );
}